import React from 'react';
import { compose } from 'ramda';
import {FIDELTOUR_CODE,STAR_TRAVELER_CODE} from '@synergycms_app/store/customer/loyaltyActions';
import { connect } from 'react-redux';
import { getLoyaltyAvailDiscountPercent } from '../../../store/avail/availUtils.js';
import {RichText} from '@synergycms_core/components/generic';
import { Image } from '@synergycms_core/components/generic/';
import { List } from 'immutable';

const LoyaltyConfirmationInfo = props => {
  const { type, loyaltyUser, loyaltyDiscount, classes, showActivateTex } = props;

   if (loyaltyUser && type === FIDELTOUR_CODE) {
      //El precio de tu reserva incluye un descuento del <b>{DESCUENTO}%</b> por ser nivel <b>{NIVEL}</b> en nuestro club de fidelización
      return (<div className={classes.userNotesContainer}>
          <div className={classes.userNotes}>
            <div className={classes.userNotesTitle}>
              <RichText translate={true} text={'_%club fidelizacion%_'} ucFirst={true} innerStyle={['droidSerif24Black','travelPointsTitle']} />
            </div>
            <div className={classes.userNotesText}>
              <RichText
                translate={true}
                dangerouslySetInnerHTML={true}
                withVars={{ DESCUENTO: loyaltyDiscount, NIVEL : loyaltyUser.getIn(["tier", "current"]) }}
                text={'_%summary fidelizacion%_'}
                ucFirst={true}
              />
            </div>
          </div>
        </div>);
    } else if(type === STAR_TRAVELER_CODE) {
      return (
        <div className={classes.webAdvantagesContainer}>
          <div className={classes.webAdvantagesBox}>
              { showActivateTex && (
                <div className={classes.activateText}>
                  <div className={classes.activateTitle}>
                    <RichText text={'_%¡activa tu cuenta Star Traveler!%_'} translate={true} innerStyle={[classes.firstLetterUpper]} />
                  </div>
                  <div className={classes.activateSubTitle}>
                    <RichText
                      text={'_%en breve, recibirás un correo electrónico para verificar tu cuenta Star Traveler y empezar a disfrutar de ventajas exclusivas%_'} translate={true} ucFirst={true} />
                  </div>
                </div>
              )}
              <div className={classes.webAdvantages}>
                <div className={classes.webAdvantagesTitle}>
                  <Image svg={'stDefaultLogoHz'} />
                  {/* {group === 'eurostarshotels' && <div className={classes.webAdvantagesTitleHeader}>Star traveler</div>} */}
                  <div>
                    <RichText text={'_%consigue beneficios exclusivos%_'} translate={true} ucFirst={true} />
                  </div>
                </div>
                <div>
                  <ul className={classes.webAdvantagesList}>
                    <li className={classes.webAdvantagesItem}><Image svg={'stIcon10Percent'} /><RichText text={'_%tarifa 10% de descuento%_'} translate={true} ucFirst={true}/></li>
                    <li className={classes.webAdvantagesItem}><Image svg={'diamond'} /><RichText text={'_%mejor precio en nuestra web%_'} translate={true} ucFirst={true}/></li>
                    {/*<li className={classes.webAdvantagesItem}><Image svg={'stIconlateCheck'} /><RichText text={'_%late check-out & early check-in%_'} translate={true} ucFirst={true}/></li>*/}
                    <li className={classes.webAdvantagesItem}><Image svg={'stIconPoints'} /><RichText text={'_%acumula puntos%_'} translate={true} ucFirst={true}/></li>
                  </ul>
                </div>
              </div>
            </div>
        </div>
      );
    }

  return null;   
};

const mapStateToProps = (store) => {
  const loyalty = store.getIn(["customer", "loyalty", "data", "loyalty"]);
  if(loyalty && loyalty.get("code")){

    const reservation = store.getIn(['customer', 'reservation']);
    const hotelId = store.getIn(['customer', 'current_hotel']);
    const discount = getLoyaltyAvailDiscountPercent(store) || 0;

    return {
      webAdvantages: store.getIn(['hotels', hotelId, "web_advantages"],List()),
      reservation: reservation.size && reservation.get('status') === 'confirmed' ? reservation : undefined,
      loyaltyDiscount : Math.abs(discount),
      loyaltyUser: reservation.getIn(['loyalty_user'], false),
      loyalty,
      type: loyalty && loyalty.get("code"),
    }
  } else {
    return {};
  }
};
  


export default compose(
  connect(mapStateToProps),
)(LoyaltyConfirmationInfo);
